import { render, staticRenderFns } from "./ConfirmCloseSheet.vue?vue&type=template&id=32d0836a&"
import script from "./ConfirmCloseSheet.vue?vue&type=script&lang=js&"
export * from "./ConfirmCloseSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports